import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"

export const MostRecentFeed = () => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  return (
    <>
      <div className="mt-16 container mx-auto">
        <div className="mx-auto flex lg:flex-row md:flex-row items-center sm:items-center flex-col text-center gap-14 lg:w-[90%]">
          <div className="lg:w-1/2 w-4/5">
            <div className="w-full flex justify-center">
              <StaticImage
                placeholder="blurred"
                className="w-full"
                src="./most-recent-feed.png"
                alt="clients"
              />
            </div>
          </div>
          <div className="w-1/2 sm:w-4/5 w-4/5">
            <div className="flex gap-2 items-center">
              <div
                className={`w-8 h-8 rounded-full ${theme == "glassy" ? "bg-[#FFFFFF73]" : theme === "light" ? "bg-completedProject bg-primary-shadow" : theme === "dark" ? "bg-completedProject bg-primary-shadow-dark" : "bg-[#FFFFFF73]"}`}
              >
                <StaticImage
                  placeholder="blurred"
                  className="w-full"
                  src="./visual-logo.png"
                  alt="clients"
                />
              </div>
              <div>
                <p className="text-black text-sm">Visual Folio</p>
              </div>
            </div>
            <div className="">
              <div className="">
                <p className="text-black lg:text-5xl md:text-sm text-start py-5 font-medium tracking-wide">
                  Behind the Scenes! Our <br />
                  <span className="text-gradient-tertiary">
                    Latest Milestones
                  </span>{" "}
                  🎯
                </p>
                <p className="text-black lg:text-sm md:text-sm text-start lg:pr-12 !text-justify">
                  Every project brings new challenges, innovations, and
                  achievements. Here’s a glimpse into our latest moments, where
                  creativity meets execution, and success takes shape. Stay
                  tuned for more milestones! 🚀
                </p>
                <div className="flex items-center gap-2 pt-5">
                  <div className="w-4 pt-1">
                    <StaticImage
                      placeholder="blurred"
                      className="w-full"
                      src="./calendar.png"
                      alt="clients"
                    />
                  </div>
                  <p className="text-black text-start">24 January 2025</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
